<app-traitement-data titre="Fuites 95" [sousTitre]="patient!.tableauDeBord?.fuites95?.date | aLaDateDu"
    [statut]="(patient!.tableauDeBord?.fuites95 | fuitesStatut)">
    {{ (patient!.tableauDeBord?.fuites95?.value | fuites) ?? 'Pas de donnée' }}
</app-traitement-data>